<div class="card">

    <p-table #miSurvey [value]="miConsolidatedTableData" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'AppId',
            'DistName',
            'Block',
            'Village',
            'Name',
            'Father_name',
            'Mobile',
            'Caste_Description',
            'Program_Name',
            'Total_Area',
            'App_ApprovalStatus',
            'User_Type',
            'App_ApprovalUser',
            'Application_Date',
            'PreEst_PendingDate',
            'PreEst_Status',
            'Est_Status',
            'Est_ApprovalStatus',
            'Est_Area',
            'Est_PendingDate',
            'Est_Status_User',
            'Challan_Status',
            'ChallanDepositDate',
            'Challan_PendingDate',
            'BOQ_Status',
            'BOQ_Amount',
            'BOQ_Date',
            'BOQ_Area',
            'BOQ_PendingDate',
            'PV_Status',
            'PV_Amount',
            'PV_Area',
            'PV_PendingUser',
            'PV_Date',
            'PV_PendingDate',
            'Calc_Status',
            'Calc_Area',
            'Calc_PendingDate',
            'Calc_Amount',
            'Calc_PendingUser',
            'ReqFinYear',
            'KYCDate',
            'KYCStatus',
            ]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end" [ngStyle]="{'color': 'black'}">
                <!-- Left side -->
                <div class="col-12 md:col-4">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{ 'MI Consolidated Detail' |
                        translate}}
                    </h5>
                </div>
                <!-- Middle section for buttons -->
                <div class="col-12 md:col-4 d-flex justify-content-center">
                    <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="miUnderProcessReport"></p-menu>

                    <!-- <label class="pr-2">{{ 'User Filter' }}</label>
                    <p-dropdown [options]="miUnderProcFilterList" appendTo="body" (onChange)="onSelectMIConsFilter()"
                        [(ngModel)]="selectedMIUnderProcFilter" placeholder="{{'ALL'| translate}}"
                        optionLabel="actionLevel" [showClear]="true"></p-dropdown> -->
                </div>
                <!-- Right side for search -->
                <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                    <!-- <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="miUnderProcessReport"></p-menu> -->
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{'APP_ID'| translate}}</th>
                <th>{{'DISTRICT'| translate}}</th>
                <th>{{'BLOCK'| translate}}</th>
                <th>{{'VILLAGE'| translate}}</th>
                <th>{{'NAME'| translate}}</th>
                <th>{{'FATHER_NAME'| translate}}</th>
                <th>{{'MOBILE_NO'| translate}}</th>
                <th>{{'CASTE'| translate}}</th>
                <th>{{'PROGRAMME_NAME'| translate}}</th>
                <th>{{'TOTAL_AREA'| translate}}</th>
                <th>{{'Approval Status'| translate}}</th>

                <th>{{'User Type'| translate}}</th>
                <th>{{'App Approval User'| translate}}</th>
                <th>{{'Application Date'| translate}}</th>
                <th>{{'Pre Est Pending Date'| translate}}</th>
                <th>{{'Pre Est Status'| translate}}</th>
                <th>{{'Est Status'| translate}}</th>
                <th>{{'Est Approva Status'| translate}}</th>
                <th>{{'Est Area'| translate}}</th>
                <th>{{'Est Pending Date'| translate}}</th>
                <th>{{'Est Status User'| translate}}</th>
                <th>{{'Challan Status'| translate}}</th>
                <th>{{'Challan Deposit Date'| translate}}</th>
                <th>{{'Challan Pending Date'| translate}}</th>
                <th>{{'BOQ Status'| translate}}</th>
                <th>{{'BOQ Amount'| translate}}</th>
                <th>{{'BOQ Date'| translate}}</th>
                <th>{{'BOQ Area'| translate}}</th>
                <th>{{'BOQ Pending Date'| translate}}</th>

                <th>{{'PV Status'| translate}}</th>
                <th>{{'PV Amount'| translate}}</th>
                <th>{{'PV Area'| translate}}</th>
                <th>{{'PV Pending User'| translate}}</th>
                <th>{{'PV Pending Date'| translate}}</th>
                <th>{{'Calc Status'| translate}}</th>
                <th>{{'Calc Area'| translate}}</th>
                <th>{{'Calc Pending Date'| translate}}</th>
                <th>{{'Calc Amount'| translate}}</th>
                <th>{{'Calc Pending User'| translate}}</th>
                <th>{{'Fin Year'| translate}}</th>
                <th>{{'KYC Date'| translate}}</th>
                <th>{{'KYC Status'| translate}}</th>
                <!-- <th>{{'Total Iterations'| translate}}</th> -->
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-consolidateData let-ri="rowIndex">
            <tr class="body-section">
                <td>{{consolidateData?.AppId}}</td>
                <td>{{consolidateData?.DistName}}</td>
                <td>{{consolidateData?.Block}}</td>
                <td>{{consolidateData?.Village}}</td>
                <td>{{consolidateData?.Name}}</td>
                <td>{{consolidateData?.Father_name}}</td>
                <td>{{consolidateData?.Mobile}}</td>
                <td>{{consolidateData?.Caste_Description}}</td>
                <td>{{consolidateData?.Program_Name}}</td>
                <td>{{consolidateData?.Total_Area}}</td>
                <td>{{consolidateData?.App_ApprovalStatus}}</td>

                <td>{{consolidateData?.User_Type}}</td>
                <td>{{consolidateData?.App_ApprovalUser}}</td>
                <td>{{consolidateData?.Application_Date}}</td>
                <td>{{consolidateData?.PreEst_PendingDate}}</td>
                <td>{{consolidateData?.PreEst_Status}}</td>
                <td>{{consolidateData?.Est_Status}}</td>
                <td>{{consolidateData?.Est_ApprovalStatus}}</td>
                <td>{{consolidateData?.Est_Area}}</td>
                <td>{{consolidateData?.Est_PendingDate}}</td>
                <td>{{consolidateData?.Est_Status_User}}</td>
                <td>{{consolidateData?.Challan_Status}}</td>
                <td>{{consolidateData?.ChallanDepositDate}}</td>
                <td>{{consolidateData?.Challan_PendingDate}}</td>
                <td>{{consolidateData?.BOQ_Status}}</td>
                <td>{{consolidateData?.BOQ_Amount}}</td>
                <td>{{consolidateData?.BOQ_Date}}</td>
                <td>{{consolidateData?.BOQ_Area}}</td>
                <td>{{consolidateData?.BOQ_PendingDate}}</td>

                <td>{{consolidateData?.PV_Status}}</td>
                <td>{{consolidateData?.PV_Amount}}</td>
                <td>{{consolidateData?.PV_Area}}</td>
                <td>{{consolidateData?.PV_PendingUser}}</td>
                <td>{{consolidateData?.PV_PendingDate}}</td>
                <td>{{consolidateData?.Calc_Status}}</td>
                <td>{{consolidateData?.Calc_Area}}</td>
                <td>{{consolidateData?.Calc_PendingDate}}</td>
                <td>{{consolidateData?.Calc_Amount}}</td>
                <td>{{consolidateData?.Calc_PendingUser}}</td>
                <td>{{consolidateData?.ReqFinYear}}</td>
                <td>{{consolidateData?.KYCDate}}</td>
                <td>{{consolidateData?.KYCStatus}}</td>
                <!-- <td>{{consolidateData?.TotalIterations}}</td> -->
            </tr>
        </ng-template>

        <ng-template pTemplate="footer">

        </ng-template>

    </p-table>

    <!-- <div class="mt-2" style="display: flex; justify-content: center;">
        <button pButton pRipple label="Back" icon="pi pi-backward" class="p-button-primary"
            (click)="onClickBack()"></button>
    </div> -->
</div>